import { Injector } from '@angular/core';
import { SmilesService } from '@sb-tools/typescript/services/smiles.service';
import { QuillHelperService } from '@sb-tools/typescript/services/quill/quill-helper.service';

export class MessageDTO {
    html = '';
    text = '';

    constructor(html: string, text: string) {
        const injector = Injector.create({
            providers: [
                {
                    provide: SmilesService,
                    deps: [],
                },
                {
                    provide: QuillHelperService,
                    deps: [],
                },
            ],
        });
        const smilesService = injector.get(SmilesService);
        const quillHelperService = injector.get(QuillHelperService);

        // @todo check do we need replaceImagesToCodes for html?
        this.html = html
            ? quillHelperService.removeResizeCursorFromImages(smilesService.replaceImagesToCodes(html))
            : null;
        this.text = text;
    }
}
